import { SplitInfoAccordionCard } from '@rsa-digital/evo-shared-components/components/SplitInfoCard';
import React from 'react';
import { unwrapSingleton } from 'helpers/csTypeProcessors';
import { nonFatalBuildError } from 'helpers/errorReporting';
import { SplitInfoCardData } from '../types';

const activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'development';
const isNotPreview = activeEnv !== 'preview';

const AccordionSplitInfoCardBlock: React.FC<{
  split_info_card: SplitInfoCardData;
}> = ({ split_info_card }) => {
  const icon = unwrapSingleton(split_info_card.icon);
  const globalPhoneNumber = unwrapSingleton(split_info_card.global_phone_number);
  /* istanbul ignore if */
  if (!icon) {
    if (isNotPreview) {
      throw new Error('Icon for Split Info Card missing!');
    }
    nonFatalBuildError(
      'Icon for Split Info Card missing!',
      'Split Info Cards require an icon to be displayed.'
    );
    return <></>;
  }

  const phoneNumber = globalPhoneNumber?.telephone_number ?? split_info_card.phone_number;
  const bodyText = split_info_card.html_body ?? split_info_card.body;

  return (
    <SplitInfoAccordionCard
      data-cy="Accordion Split Info Card"
      icon={icon.icon_code}
      heading={split_info_card.heading}
      body={bodyText || ''}
      phoneNumber={phoneNumber}
      phoneNumberAria={globalPhoneNumber?.screen_reader_text}
      openingHours={split_info_card.opening_hours}
    />
  );
};

export default React.memo(AccordionSplitInfoCardBlock);
